import React from 'react'
import { constants } from 'common/helpers'

import composeDialogModal from 'components/modal/DialogModal/composeDialogModal'

import messages from './messages'


const GiftRedeemedModal = composeDialogModal({
  name: constants.modals.gifts.GiftRedeemed,
  buttonTitle: messages.buttonTitle,
  contentMessage: { ...messages.text, tag: 'div' },
})

export default GiftRedeemedModal
